import { render, staticRenderFns } from "./FormatReferencesTreeSelector.vue?vue&type=template&id=a7b3cca4&scoped=true&"
import script from "./FormatReferencesTreeSelector.vue?vue&type=script&lang=ts&"
export * from "./FormatReferencesTreeSelector.vue?vue&type=script&lang=ts&"
import style0 from "./FormatReferencesTreeSelector.vue?vue&type=style&index=0&id=a7b3cca4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b3cca4",
  null
  
)

export default component.exports